import type { CreateUserInput, UpdateUserInput } from '@crm/shared';
import { apiClient } from '@/lib/api-client';
import type { PaginationMeta, PublicUser } from '@/modules/auth/types';
import type { UserStatusFilter } from '../constants';
import { USERS_ENDPOINTS } from '../constants';

export interface UsersListResponse {
  data: PublicUser[];
  meta: PaginationMeta;
}

/** Chamadas HTTP da gestao de usuarios. */
export const usersService = {
  list(params: { page: number; perPage?: number; search?: string; status?: UserStatusFilter }) {
    const query = new URLSearchParams({
      page: String(params.page),
      perPage: String(params.perPage ?? 20),
      status: params.status ?? 'all',
    });

    if (params.search) query.set('search', params.search);

    return apiClient.get<UsersListResponse>(`${USERS_ENDPOINTS.LIST}?${query.toString()}`);
  },

  get(id: string) {
    return apiClient.get<PublicUser>(USERS_ENDPOINTS.detail(id));
  },

  create(input: CreateUserInput) {
    return apiClient.post<PublicUser>(USERS_ENDPOINTS.LIST, input);
  },

  update(id: string, input: UpdateUserInput) {
    return apiClient.patch<PublicUser>(USERS_ENDPOINTS.detail(id), input);
  },

  remove(id: string) {
    return apiClient.delete<{ message: string }>(USERS_ENDPOINTS.detail(id));
  },
};
